import styled from 'styled-components';

export const AccountRecoveryOptions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
